import { createAction } from 'redux-starter-kit';

export const SET_BRIEFINGS = 'briefings/SET_BRIEFINGS';
export const CLEAR_BRIEFINGS = 'briefings/CLEAR_BRIEFINGS';
export const SET_BRIEFING = 'briefings/SET_BRIEFING';
export const CLEAR_BRIEFING = 'briefings/CLEAR_BRIEFING';

export default {
  setBriefings: createAction(SET_BRIEFINGS),
  clearBriefings: createAction(CLEAR_BRIEFINGS),
  setBriefing: createAction(SET_BRIEFING),
  clearBriefing: createAction(CLEAR_BRIEFING),
};
